import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const xSellingPopupInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Title",
  },
  {
    name: "subtitle",
    type: "string",
    required: true,
    defaultValue: "Subtitle",
  },
  {
    name: "confirmButtonText",
    type: "string",
    required: true,
    defaultValue: "Confirm",
  },
  {
    name: "cancelButtonText",
    type: "string",
    required: true,
    defaultValue: "Cancel",
  },
  {
    name: "confirmRedirectUrl",
    type: "string",
    required: true,
    defaultValue: "/",
  },
  {
    name: "showQuickAddToCartButton",
    type: "boolean",
    required: false,
    defaultValue: false,
    friendlyName: "Show Quick Add to Cart button",
    helperText:
      "When enabled, displays a 'Quick add to cart' button for simple products alongside the Discover button.",
  },
] as const satisfies Inputs;

export const XSellingPopupComponent: RegisteredComponent = {
  name: "X-Selling Popup",
  component: dynamic(
    async () => withValidation(xSellingPopupInputs, (await import("./XSellingPopup")).XSellingPopup, "XSellingPopup"),
    { ssr: false }
  ),
  models: [getBuilderModelName("x-selling-popup")],
  inputs: xSellingPopupInputs,
};
